import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { call, cancel, put, select, takeEvery } from 'redux-saga/effects';
import {
  AngebotsId,
  ANTRAGSNUMMER_EVENTS,
  DoRequestResponse,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { VwgAction, VwgActions } from '../vwgActions';
import { IAppState } from '../appState';

export function* watchAntragsnummerRequested(): SagaIterator {
  yield takeEvery(GlobalActions.ANTRAGSNUMMER_REQUESTED, safeSaga(antragsnummerRequested, App.VWG_V2));
  yield takeEvery(VwgActions.VORSCHLAGDATEN_CHANGED, safeSaga(vorschlagsDatenChanged, App.VWG_V2));
  yield takeEvery(
    ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
    safeSaga(successCallback, App.VWG_V2),
  );
}

export function* antragsnummerRequested(action: GlobalAction<AngebotsId>): SagaIterator {
  const store: IAppState = yield select();
  const angebotsIdInStore = store.angebotsId;
  const { appId, angebotsId } = action.payload;

  if (appId === App.VWG_V2 && angebotsId === angebotsIdInStore) {
    return yield call(antragsnummerSaga, angebotsIdInStore);
  }
}

export function* vorschlagsDatenChanged(action: VwgAction<string>): SagaIterator {
  yield call(antragsnummerSaga, action.payload);
}

export function* antragsnummerSaga(angebotsId: string): SagaIterator {
  const globalPut = GlobalPut.getInstance();

  yield call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequestAntragsnummer(
      App.VWG_V2,
      ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
      ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
      angebotsId,
    ),
  );
}

export function* successCallback(successAction: DoRequestResponse<string>): SagaIterator {
  try {
    if (successAction.doRequestAction.payload.appId === App.VWG_V2) {
      const globalPut = GlobalPut.getInstance();
      const antragsnummerAsString = successAction.payload.toString();
      yield put(
        new VwgActions().antragsnummerGenerated(
          antragsnummerAsString,
          successAction.doRequestAction.payload.angebotsId,
        ),
      );
      yield call(globalPut.put, new GlobalActions().antragsnummerGenerated());
    }
  } catch (exception) {
    PS20Logger.error(
      App.VWG_V2,
      exception as Error,
      'AntragsnummerSaga successCallback Antragsnummer konnte nicht verarbeitet werden',
    );
    yield cancel();
  }
}
